module.exports = __webpack_public_path__ + "img/logo_brandme-square.4935a6d0.jpeg";